export const AlertModalInjection = Symbol('AlertModal');
export const LoadingModalInjection = Symbol('LoadingModal');